module.exports = __webpack_public_path__ + "img/passport.4377421c.png";